import { render } from "./Offering.vue?vue&type=template&id=b46db9e6&scoped=true"
import script from "./Offering.vue?vue&type=script&lang=js"
export * from "./Offering.vue?vue&type=script&lang=js"

import "./Offering.vue?vue&type=style&index=0&id=b46db9e6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46db9e6"]])

export default __exports__